// extracted by mini-css-extract-plugin
export var copy = "HandheldOptimizationSection-module__copy___6iHfr";
export var handheldOptimizationSection = "HandheldOptimizationSection-module__handheldOptimizationSection___qMyLh";
export var warning = "HandheldOptimizationSection-module__warning___mQv3Y";